
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 19","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.75 13.5a.75.75 0 00-1.5 0h1.5zm16 0a.75.75 0 00-1.5 0h1.5zm-4.22-3.47a.75.75 0 10-1.06-1.06l1.06 1.06zM9 13.5l-.53.53a.75.75 0 001.06 0L9 13.5zM5.53 8.97a.75.75 0 00-1.06 1.06l1.06-1.06zM9.75 1.5a.75.75 0 00-1.5 0h1.5zM14 16.75H4v1.5h10v-1.5zM1.75 14.5v-1H.25v1h1.5zm14.5-1v1h1.5v-1h-1.5zM14 18.25a3.75 3.75 0 003.75-3.75h-1.5A2.25 2.25 0 0114 16.75v1.5zm-10-1.5a2.25 2.25 0 01-2.25-2.25H.25A3.75 3.75 0 004 18.25v-1.5zm8.47-7.78l-4 4 1.06 1.06 4-4-1.06-1.06zm-2.94 4l-4-4-1.06 1.06 4 4 1.06-1.06zm.22.53v-12h-1.5v12h1.5z"}})])
          )
        }
      }
    